import {
    CBT_GET_MULTIPLE,
    CBT_GET_ONE,
    CBT_SET_ONE,
    CBT_REGISTER_SUCCESS,
    CBT_REGISTER_FAIL,
    CBT_LOADING,
    CBT_LOADING_ERROR,
    CBT_ACTIVATE_FAIL,
    CBT_ACTIVATE_SUCCESS,
    CBT_UPDATE_SUCCESS,
    CBT_UPDATE_FAIL,
    CBT_DELETE_SUCCESS,
    CBT_DELETE_FAIL,
    CBT_EDIT
} from "./../types/cbt";

let cbtStore = JSON.parse(localStorage.getItem('cbt'))
let cbtTestStore = JSON.parse(localStorage.getItem('test_data'))

const initialState = {
    isLoading: false,
    cbts: cbtStore ? cbtStore : [],
    cbt:{},
    cbtTests: cbtTestStore ? cbtTestStore : {},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newCbt = [...aluu];
    newCbt.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newCbt;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case CBT_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case CBT_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case CBT_GET_MULTIPLE:
            localStorage.setItem('cbt', JSON.stringify(action.payload));
            return {
                ...state,
                cbts : action.payload,
                cbt : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case CBT_GET_ONE:
            let all = [...state.cbts];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                cbt : ses,
                MSG:"DONE!!!"
            };
        case CBT_SET_ONE:
            let al = {...state.cbtTests};
            if(al.hasOwnProperty(action.payload.testid)){
                al[action.payload.testid] = action.payload.data
            }else{
                al[action.payload.testid] = action.payload.data
            }
            localStorage.setItem('test_data', JSON.stringify(al));
            //get multiple
            let g_cbt = [...state.cbts]
            //check id test id exist
            let cbt_index = g_cbt.findIndex(rw=>rw.testid == action.payload.testid)
            
            if(cbt_index > -1){
                g_cbt[cbt_index] = action.payload.data
            }else{
                let cbt_index_id = g_cbt.findIndex(rw=>rw.id == action.payload.data.id)
                if(cbt_index_id > -1){
                    g_cbt[cbt_index_id] = action.payload.data
                }else{
                    g_cbt.push(action.payload.data)
                }
            }
            localStorage.setItem('cbt', JSON.stringify(g_cbt));
            console.log(al, g_cbt)
            return {
                ...state,
                cbtTests : al,
                cbts: g_cbt,
                MSG:"DONE!!!"
            };
        case CBT_REGISTER_SUCCESS:
            localStorage.setItem('cbt', JSON.stringify([...state.cbts, action.payload]));
            return {
                ...state,
                cbts: [...state.cbts, action.payload],
                msg:action.msg
            }; 
        case CBT_ACTIVATE_SUCCESS:
            let ac = changeState(state.cbts, action.payload);
            localStorage.setItem('cbt', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                cbts: ac
            }
        case CBT_DELETE_SUCCESS:
            let rem = state.cbts.filter(cat => cat.id != action.payload);
            localStorage.setItem('cbt', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                cbts: rem
            }
        case CBT_UPDATE_SUCCESS:
            const findInd = state.cbts.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.cbts];
            newState[findInd] = action.payload;
            localStorage.setItem('cbt', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                cbts : newState,
                cbt:action.payload
            }; 
        case CBT_LOADING_ERROR:
        case CBT_ACTIVATE_FAIL:
        case CBT_REGISTER_FAIL:
        case CBT_DELETE_FAIL:
        case CBT_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func